var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var Header = styled.h2(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: var(--checkout-gray800);\n  font-size: var(--checkout-font-size-16);\n  padding: var(--spacing) 0;\n  font-weight: 500;\n"], ["\n  color: var(--checkout-gray800);\n  font-size: var(--checkout-font-size-16);\n  padding: var(--spacing) 0;\n  font-weight: 500;\n"])));
var templateObject_1;
//# sourceMappingURL=Header.js.map